<script>
import generalHelpers from "@/helpers/generalHelpers";

  export default{
      downloadFile(context, bytesBase64, fileName, appType){
            const blob = generalHelpers.convertBase64StringToBlob(bytesBase64, appType);
            
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            URL.revokeObjectURL(link.href);
      },
  }
</script>